import { gateway } from "../../../gateway";

export const postMyWorkforce = async (data, token) => {
  const res = await gateway.post("/workforce/", data, {
    headers: {
      Authorization: `${token}`,
    },
  });
  return res.data || res.data.data;
};